<div class="clearfix"
     click-outside>
  <div class="ui-extra-products-collapse-container">
    <div class="ui-extra-products-compensator">
      <div class="ui-extra-products-collapse-wrap"
           [style.height.px]="contentHeight"
           #wrap>
        <div class="ui-extra-products-collapse-content" #content>
          <ng-container *ngFor="let item of items; let ind = index">
            <div class="d-flex justify-content-between align-items-center extra-product-wrap"
                 [class.position-relative]="isShowOverlay(ind)"
                 [class.show-extra-product]="isShowExtraProduct(ind)"
                 [class.extra-product-disabled]="isDisabled(item)">
              <div>
                <label class="extra-product-label cursor-pointer">
                  <input type="checkbox"
                         class="extra-product-input"
                         [disabled]="isDisabled(item)"
                         [(ngModel)]="item.selected"
                         (change)="onChange(item)">
                  <div class="checkbox-icon-wrap">
                    <i class="selected-icon icon-checkbox-blank-outline font-2xl" *ngIf="!item.selected"></i>
                    <i class="selected-icon icon-checkbox-marked font-2xl text-primary" *ngIf="item.selected"></i>

                    <div class="font-lg">
                      <span class="fw-bold">{{ item.label }}</span>
                      <span *ngIf="!item.hidePrice && item.priceLabel">, + {{ item.priceLabel }}</span>
                    </div>
                    <div class="font-sm text-muted" *ngIf="item.value?.description">
                      {{ item.value.description }}
                    </div>
                  </div>

                </label>
              </div>
              <div *ngIf="showPictures && item.value?.picture">
                <div class="ui-extra-products-img">
                  <img (click)="$event.stopPropagation(); selectImage(item.value.picture, $event)"
                       [src]="item.value?.picture | multiImage: 'smallUrl': true : '/assets/img/content/default-cake-image.jpg'">
                </div>
              </div>
              <div class="ui-collapser-overlay" *ngIf="isShowOverlay(ind)"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="ui-extra-products-collapser" *ngIf="!isExpand">
      <div class="ui-extra-show-hide-btn"
           (click)="$event.stopPropagation(); toggle(); onImageSelect.emit({ show: false });">
        <span class="fw-bold"
              [translate]="'cakeBuilder.extraProductsSection.showMore'">Show more</span>
        <i class="icon-chevron-down text-pink"></i>
      </div>
    </div>
  </div>
</div>
